<script>
import { range } from "lodash";

export default {
  props: {
    current: {
      type: Number,
      required: true,
    },
    maximum: {
      type: Number,
      required: true,
    },
  },
  data() {
    return { display: 3, minimum: 1 };
  },
  computed: {
    buttons() {
      if (this.maximum - this.minimum <= 5) {
        return range(this.minimum, this.maximum + 1);
      }
      let min = this.current - 1;
      let max = this.current + 1;
      if (!this.prefix) {
        min = this.minimum;
        max = this.minimum + (this.display + 1);
      }
      if (!this.suffix) {
        max = this.maximum;
        min = this.maximum - (this.display + 1);
      }
      if (min < this.minimum) {
        min = this.minimum;
      }
      if (max > this.maximum) {
        max = this.maximum;
      }
      return range(min, max + 1);
    },
    prefix() {
      return (
        this.maximum - this.minimum > 5 &&
        this.current >= this.minimum + (this.display + 1)
      );
    },
    suffix() {
      return (
        this.maximum - this.minimum > 5 &&
        this.current <= this.maximum - (this.display + 1)
      );
    },
  },
  methods: {
    goto(page) {
      this.$emit("goto", { page });
    },
  },
};
</script>

<template>
  <div class="pagesContainer">
    <button v-if="current > minimum" class="cursor-pointer p-2 text-gray-700 hover:bg-gray-400 hover:text-white"
      type="button" @click="goto(current - 1)">
      &lt;
    </button>
    <button v-if="prefix" class="cursor-pointer p-2 text-gray-700 hover:bg-gray-400 hover:text-white" type="button"
      @click="goto(minimum)">
      {{ minimum }}
    </button>
    <span v-if="prefix">...</span>
    <button v-for="button in buttons" :key="button" :class="button === current ? 'activePage' : ''"
      class="cursor-pointer p-2 text-gray-700 hover:bg-gray-400 hover:text-white" type="button" @click="goto(button)">
      {{ button }}
    </button>
    <span v-if="suffix">...</span>
    <button v-if="suffix" class="cursor-pointer p-2 text-gray-700 hover:bg-gray-400 hover:text-white" type="button"
      @click="goto(maximum)">
      {{ maximum }}
    </button>
    <button v-if="current < maximum" class="cursor-pointer p-2 text-gray-700 hover:bg-gray-400 hover:text-white"
      type="button" @click="goto(current + 1)">
      &gt;
    </button>
  </div>
</template>

<style scoped>
.activePage {
  @apply bg-gray-400 text-white;
}
</style>

